import React from 'react';
import { GlobalStyle, C, BODY } from '../components/landing/shared';
import { LandingNav } from '../components/landing/LandingNav';
import { HeroSection } from '../components/landing/HeroSection';
import { ProofStrip } from '../components/landing/ProofStrip';
import { ScannerSection } from '../components/landing/ScannerSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { OutcomesSection } from '../components/landing/OutcomesSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { HabitLoopSection } from '../components/landing/HabitLoopSection';
import { CampaignDemoSection } from '../components/landing/CampaignDemoSection';
import { FounderStorySection } from '../components/landing/FounderStorySection';
import { ComparisonSection } from '../components/landing/ComparisonSection';
import { PricingSection } from '../components/landing/PricingSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
import { LandingFooter } from '../components/landing/LandingFooter';

export default function LandingPage() {
  return (
    <div data-testid="landing-page-v3" style={{ background: C.bg, color: C.text, fontFamily: BODY, minHeight: '100vh' }}>
      <GlobalStyle />
      <LandingNav />
      <main>
        <HeroSection />
        <ProofStrip />
        <ScannerSection />
        <ProblemSection />
        <OutcomesSection />
        <HowItWorksSection />
        <HabitLoopSection />
        <CampaignDemoSection />
        <FounderStorySection />
        <ComparisonSection />
        <PricingSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <LandingFooter />
    </div>
  );
}
